export default __webpack_public_path__ + "static/media/cabello-corto-hombre-verde.3ffa6e2d.png";